var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.label,"placement":"bottom"}},[_c('router-link',{class:_vm.linkClass,attrs:{"to":_vm.computedRoute}},[_c('i',{class:[_vm.iconClass, _vm.iconExtraClass]}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }